import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-下载中心",
  "use": "icon-下载中心-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-下载中心\">\n<path d=\"M114.978 42L133.489 46.6522L136.885 47.7408C143.507 49.864 148 56.0223 148 62.977V133C148 141.837 140.837 149 132 149H28C19.1634 149 12 141.837 12 133V63.5141C12 56.3041 16.8224 49.9847 23.7768 48.0816L29 46.6522L46 42\" stroke-width=\"10\" stroke-linecap=\"round\" />\n<path d=\"M81.6345 12V109.945M57 89.4436L81.6345 111L104 89.4436\" stroke-width=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/下载中心.svg
// module id = XLpP
// module chunks = 26